import type { Blog } from '@ztechapps/common.contract'
import { toDate } from '@ztechapps/common.utils'

type WhatsNewPost = Pick<Blog, '_id' | 'createdAt' | 'updatedAt'>

/**
 * A What's New post is unseen when it was created after the last post the user saw (or the user saw none). Creation time,
 * never `updatedAt`, so editing or re-statusing an older post cannot resurface it. No latest post means nothing to show.
 */
export function isWhatsNewUnseen({
  latest,
  seen,
}: {
  latest: WhatsNewPost | null | undefined
  seen: WhatsNewPost | null | undefined
}): boolean {
  if (!latest) {
    return false
  }

  if (!seen) {
    return true
  }

  return toDate(latest.createdAt).isAfter(toDate(seen.createdAt))
}
